/**
 * @owner @Appboy/content-cards
 *
 * @fileoverview GET handler for the "/engagement/placement_campaign_bases_data_v2" endpoint.
 * Fetches placement-scoped campaign bases (campaigns + canvas steps) for the CampaignList in Placements.
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import type { EngagementCampaignsDataV2Params } from "../engagementCampaignsDataV2";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPlacementCampaignBasesDataV2 } from "./constants";
import type { PlacementCampaignBasesResult } from "./types";

export const getDataTableEngagementPlacementCampaignBasesDataV2 = reactQueryTableFetcherAdapter(
  engagementPlacementCampaignBasesDataV2,
  async (
    signal: AbortSignal,
    { appGroupId, query, limit = 20, start = 0, ...rest }: EngagementCampaignsDataV2Params
  ): Promise<PlacementCampaignBasesResult> => {
    return fetch(
      engagementPlacementCampaignBasesDataV2,
      "GET",
      {
        limit,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query ?? {}),
        ...rest,
      },
      { signal }
    );
  }
);
